const FormatCompany = (str) => {
    if (!str || typeof str !== 'string') return "";

    //Remove punctuation marks from these since we do it with the data.
    const suffixes = [
        "BV", "S DE RL DE CV", "SA DE CV", "SA DE CV", "SA de CV",
        "SAB de CV", "S DE CV", "SAB", "DE CV", "S DE RL", "S DE RL",
        "S DE RL DE CV", "S DE R L DE C V", "SDE RL", "SA"
    ];

    const connectors = ["y", "de", "del"]

    //Remove every possible punctuation mark from the names
    let cleanedStr = str.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '').replace(/\s+/g, ' ').trim();

    //Ensure to check for larger suffixes before the short ones.
    const sortedSuffixes = suffixes.sort((a, b) => b.length - a.length);

    for (const suffix of sortedSuffixes) {
        if (cleanedStr.toLowerCase().endsWith(suffix.toLowerCase())) {
            //Slice the string and trim any spaces in case the suffix is stick to the name
            cleanedStr = cleanedStr.slice(0, -suffix.length).trim();
            break;
        }
    }
    
    return cleanedStr.split(' ').map(word => {
        if (word.toLowerCase() === "sa") return ""; //This won't be removed unless we do it manually, due to its length;
        if(connectors.includes(word.toLowerCase())) return word.toLowerCase();

        if (word.length <= 3) return word;   //Don't format short names or fragments
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
}

export default FormatCompany;